const IS_QA = /(qa.)/.test( window.location.host );
const IS_PPRD = /(pprd.)/.test( window.location.host );
const IS_LOCALHOST = /(localhost:)/.test( window.location.host );
const IS_LOCAL_IP = /(172.)/.test( window.location.host );
const ENV = `${ ( IS_LOCALHOST || IS_QA || IS_LOCAL_IP ) ? 'qa.' : IS_PPRD ? 'pprd.' : '' }`;
const EVENT_ENVIRONMENT = `${ ( IS_LOCALHOST || IS_QA || IS_LOCAL_IP ) ? 'qa' : IS_PPRD ? 'pprd' : 'prod' }`;

export {
    IS_QA,
    IS_PPRD,
    IS_LOCALHOST,
    ENV,
    EVENT_ENVIRONMENT
};